import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

export function SplashScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-zinc-900/95 backdrop-blur-sm z-50">
      <div className="relative w-48 h-48 flex items-center justify-center">
        {/* Outer Ring - Thicker */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: [0.2, 0.5, 0.2],
            rotate: 360,
            scale: [1, 1.2, 1],
          }}
          transition={{
            duration: 3,
            ease: "linear",
            repeat: Infinity,
          }}
          className="absolute inset-0 border-4 border-blue-500/30 rounded-2xl"
        />

        {/* Middle Ring */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: [0.3, 0.7, 0.3],
            rotate: -360,
            scale: [0.9, 1.1, 0.9],
          }}
          transition={{
            duration: 3,
            ease: "linear",
            repeat: Infinity,
          }}
          className="absolute inset-0 border-2 border-indigo-500/40 rounded-2xl"
        />

        {/* Inner Ring - Thinner */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: [0.4, 0.6, 0.4],
            rotate: 180,
            scale: [0.8, 1, 0.8],
          }}
          transition={{
            duration: 2,
            ease: "linear",
            repeat: Infinity,
          }}
          className="absolute inset-0 border-1 border-purple-400/30 rounded-2xl"
        />

        {/* Glow effects */}
        <div className="absolute -inset-4 bg-blue-600/10 blur-xl rounded-full opacity-30"></div>
        <div className="absolute -inset-8 bg-indigo-600/10 blur-3xl rounded-full opacity-20"></div>

        {/* Logo Container */}
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.5,
            ease: "easeOut",
            delay: 0.2,
          }}
          className="relative z-10"
        >
          <Logo
            variant="default"
            textColor="white"
            size="lg"
            className="scale-150"
          />
        </motion.div>
      </div>

      {/* Loading text */}
      <motion.div
        className="absolute bottom-16 text-zinc-400 text-sm font-medium"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        <motion.div
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          Loading...
        </motion.div>
      </motion.div>
    </div>
  );
}

export default SplashScreen;
